/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// @ts-nocheck
import LoadingSpinner from 'components/LoadingSpinner'
import PopupMessage from 'components/popup-message'
import PopupOtp from 'components/popup-otp'
import AppConfigs from 'configs/env'
import {
  ALLOW_PHONE_LIST,
  APP_MESSAGE,
  CAMPAIGNID,
  CLICK_ACTION_POPUP_MESSAGE,
  END_DATE,
  ERROR_CODE,
  frameList,
  LISTSONG,
  SHOW_POPUP_REDIRECT_LOGIN,
  START_DATE,
  WISHLISTS,
} from 'constants/common'
import { utc } from 'moment'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import actions from 'redux/home/actions'
import HomePageView from './view'
import { getIsAeonSelector, getIsCompletedSelector, getIsOfflineSelector, getTransactionIdSelector } from 'redux/home/selectors'
import eventEmitter from 'help/eventEmitter'
import { signInWithCustomToken, getAuth } from 'firebase/auth'
import { LoadingContext } from 'contexts/Loading'
import { PopupMessageContext } from 'contexts/PopupMessage'
import { store } from 'redux/configureStore'

const HomePage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm()
  const { setIsLoading } = useContext(LoadingContext)
  const { isShowPopup, togglePopupMessage, resetPopupMessage, showPopupMessage, closePopupMessage } = useContext(PopupMessageContext)
  const [modalOtp, setModalOtp] = useState(false)
  const [otp, setOtp] = useState('')
  const [isErrorOTP, setIsErrorOTP] = useState(false)
  const [otpRequestTime, setOtpRequestTime] = useState('')
  const [otpResponseTime, setOtpResponseTime] = useState('')
  const [dataSubmit, setDataSubmit] = useState({})
  const [isErrorPhoneNumber, setIsErrorPhoneNumber] = useState(false)
  const [hasJoinedToothlens, setHasJoinedToothlens] = useState(false)
  const [triggerReload, setTriggerReload] = useState(false)
  const transactionId = useSelector((state) => getTransactionIdSelector(state))
  const isCompleted = useSelector((state) => getIsCompletedSelector(state))

  useEffect(() => {
    checkQueryIsOffline()
    checkQueryIsAeon()
    validateCampaign()
    if (hasJoinedToothlens) reset()
  }, [])

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (!hasJoinedToothlens || isCompleted) {
        return
      }
      console.log('watch', { value, name })
      if (name == 'phoneNumber') {
        validatePhoneNumber(value.phoneNumber)
      }
      if (!!value.fullName && value.phoneNumber.length == 10 && !isErrorPhoneNumber && value.isAgree) {
        removeDisableBtn('#btn-register')
      } else {
        addDisableBtn('#btn-register')
      }
    })
    return () => subscription.unsubscribe()
  }, [watch, isErrorPhoneNumber, hasJoinedToothlens, isCompleted])

  useEffect(() => {
    if (otp.length === 6) handleSubmitOTP()
  }, [otp])

  useEffect(() => {
    eventEmitter.addListener(SHOW_POPUP_REDIRECT_LOGIN, () => {
      setIsLoading(false)
      showDefaultErrModal()
    })
    return () => eventEmitter.removeListener(SHOW_POPUP_REDIRECT_LOGIN, () => {})
  }, [])

  useEffect(() => {
    eventEmitter.addListener(CLICK_ACTION_POPUP_MESSAGE, onClickAction)
    return () => eventEmitter.removeListener(CLICK_ACTION_POPUP_MESSAGE, () => {})
  }, [triggerReload])

  useEffect(() => {
    if (isShowPopup) {
      document.body.classList.add('modal-open')
    } else {
      if (document.body.classList.contains('modal-open')) document.body.classList.remove('modal-open')
    }
  }, [isShowPopup])

  const validatePhoneNumber = (phoneNumber) => {
    if (
      phoneNumber[0] != '0' ||
      !ALLOW_PHONE_LIST.includes(phoneNumber.slice(0, 3)) ||
      (phoneNumber.slice(0, 3) === '077' && !ALLOW_PHONE_LIST.includes(phoneNumber.slice(0, 4)))
    ) {
      setIsErrorPhoneNumber(true)
    } else {
      setIsErrorPhoneNumber(false)
    }
  }
  const validateCampaign = () => {
    setIsLoading(true)
    dispatch(
      actions.VALIDATE_CAMPAIGN.request(
        {},
        (res) => {
          setIsLoading(false)
          if (!res.isSuccess) {
            checkError(res?.error?.message)
          } else {
            checkQueryTransactionId()
          }
        },
        (err) => {
          setIsLoading(false)
          checkError(err?.data?.error?.message)
        }
      )
    )
  }
  const checkQueryIsAeon = () => {
    if (searchParams.get('isAeon')) {
      dispatch(actions.UPDATE_HOME_STATE.request({ key: 'isAeon', value: JSON.parse(searchParams.get('isAeon')) }))
    }
  }
  const checkQueryIsOffline = () => {
    if (searchParams.get('isOffline')) {
      dispatch(actions.UPDATE_HOME_STATE.request({ key: 'isOffline', value: JSON.parse(searchParams.get('isOffline')) }))
    }
  }
  const checkQueryTransactionId = () => {
    if (searchParams.get('transactionId')) {
      if (transactionId && transactionId === searchParams.get('transactionId')) {
        checkTransactionId(transactionId)
      } else {
        checkTransactionId(searchParams.get('transactionId'))
      }
      return
    }
    if (!transactionId) {
      createTransactionId().catch((err) => {})
    } else {
      checkTransactionId(transactionId)
    }
  }
  const createTransactionId = async () => {
    const isOffline = getIsOfflineSelector(store.getState())
    const isAeon = getIsAeonSelector(store.getState())
    return new Promise((resolve, reject) => {
      dispatch(
        actions.GENERATE_TRANSACTION_ID.request(
          { isOffline, isAeon },
          (res) => {
            resolve(res)
          },
          (err) => {
            reject(err)
          }
        )
      )
    })
  }
  const checkTransactionId = (transactionId) => {
    setIsLoading(true)
    dispatch(
      actions.CHECK_TRANSACTION_ID.request(
        { transactionId },
        (res) => {
          setIsLoading(false)
          if (res?.data?.hasreport) {
            setHasJoinedToothlens(true)
          } else setHasJoinedToothlens(false)
        },
        (err) => {
          setIsLoading(false)
          if (err?.error?.message === ERROR_CODE.TRANSACTION_NOT_FOUND) {
            createTransactionId()
          }
        }
      )
    )
  }
  const checkPhoneNumber = (data) => {
    dispatch(
      actions.CHECK_PHONE_NUMBER.request(
        { phoneNumber: data.phoneNumber },
        (res) => {
          if (res?.isSuccess) {
            requestOTP(data)
          }
        },
        (err) => {
          setIsLoading(false)
          checkError(err?.error?.message)
        }
      )
    )
  }
  const uncheckConsent = () => {
    setValue('isAgree', false)
  }
  const closeModalOTP = () => {
    uncheckConsent()
    clearModalOtp()
  }
  const clearModalOtp = () => {
    setIsErrorOTP(false)
    setOtp('')
    setModalOtp(false)
  }
  const handleChangeOTP = (value) => {
    setOtp(value)
  }
  const handleSubmitOTP = () => {
    console.log('OTP===>', otp)
    setIsLoading(true)
    dispatch(
      actions.VERIFY_OTP.request(
        {
          phoneNumber: dataSubmit.phoneNumber,
          otpCode: otp,
        },
        (res) => {
          requestLogin(otpRequestTime, res?.token?.accessToken)
        },
        (err) => {
          setIsLoading(false)
          setIsErrorOTP(true)
        }
      )
    )
  }
  const handleResendOTP = () => {
    setIsErrorOTP(false)
    setOtp('')
    requestOTP(dataSubmit)
  }
  const requestOTP = (data) => {
    console.log('data', data)
    setIsLoading(true)
    setIsErrorOTP(false)
    setOtpRequestTime(utc().format())
    setOtp('')
    localStorage.setItem('accessToken', '')
    dispatch(
      actions.REQUEST_OTP.request(
        {
          phoneNumber: data.phoneNumber,
          campaignId: parseInt(CAMPAIGNID),
        },
        (res) => {
          setOtpResponseTime(utc().format())
          // OTPLog(res, data);
          setDataSubmit(data)
          setModalOtp(true)
          console.log('success', res)
          setIsLoading(false)
        },
        (err) => {
          console.log('err', err)
          setIsLoading(false)
          checkError(err?.data?.error?.message)
        }
      )
    )
  }
  const requestLogin = (verifyOTPRequestTime, accessToken) => {
    signInWithCustomToken(getAuth(), accessToken)
      .then((authCredential) => {
        let user = authCredential?.user
        console.log('user', user)
        localStorage.setItem('accessToken', user.accessToken || '')
        receivedReport(user)
      })
      .catch((error) => {
        console.error('Error requestLogin: ', error)
        setIsLoading(false)
        showDefaultErrModal()
      })
  }
  const receivedReport = (user) => {
    const formatData = {
      fullName: dataSubmit.fullName,
      phoneNumber: dataSubmit.phoneNumber,
      isConsent: dataSubmit.isAgree,
      otp,
      transactionId,
    }
    console.log('formatData', formatData)
    dispatch(
      actions.RECEIVED_REPORT.request(
        formatData,
        (res) => {
          console.log('res :>>>', res)
          setIsLoading(false)
          clearModalOtp()
          showPopupMessage(APP_MESSAGE.JOIN_SUCCESS, 'ĐÓNG')
        },
        (err) => {
          console.error('Error receivedReport: ', err)
          setIsLoading(false)
          showDefaultErrModal()
        }
      )
    )
  }
  const addDisableBtn = (id) => {
    const el = document.querySelector(id)
    el.classList.add('disabled')
  }
  const removeDisableBtn = (id) => {
    const el = document.querySelector(id)
    el.classList.remove('disabled')
  }
  const onSubmit = async (data) => {
    if (!hasJoinedToothlens) {
      if (!transactionId) {
        createTransactionId()
          .then((res) => {
            let transactionId = res?.data?.transactionId
            openToothlensUrl(transactionId)
          })
          .catch((err) => {
            setTriggerReload(true)
            showDefaultErrModal()
          })
      } else {
        openToothlensUrl(transactionId)
      }
    } else {
      console.log('data', data)
      setIsLoading(true)
      checkPhoneNumber(data)
    }
  }
  const checkError = (errCode) => {
    let content = ''
    switch (errCode) {
      case ERROR_CODE.CAMPAIGN_NOT_STARTED:
        content = APP_MESSAGE.CAMPAIGN_NOT_STARTED
        break

      case ERROR_CODE.CAMPAIGN_ENDED:
        content = APP_MESSAGE.CAMPAIGN_ENDED
        break

      case ERROR_CODE.INVALID_PHONE_NUMBER:
        content = APP_MESSAGE.INVALID_PHONE_NUMBER
        break

      case ERROR_CODE.EXCEEDED_REGISTRATION_LIMIT:
        content = APP_MESSAGE.EXCEEDED_REGISTRATION_LIMIT
        break

      case ERROR_CODE.INVALID_RESEND_TIME:
        content = APP_MESSAGE.INVALID_RESEND_TIME
        break

      default:
        content = `${APP_MESSAGE.ERROR_COMMON}`
        break
    }
    if (errCode === ERROR_CODE.CAMPAIGN_NOT_STARTED || errCode === ERROR_CODE.CAMPAIGN_ENDED) {
      showPopupMessage(content, '')
    } else {
      showPopupMessage(content, 'ĐÓNG')
    }
  }
  const showDefaultErrModal = () => {
    showPopupMessage(APP_MESSAGE.ERROR_COMMON, 'ĐÓNG')
  }
  const onClickAction = (e) => {
    if (triggerReload) {
      window.location.reload()
    } else {
      uncheckConsent()
      closePopupMessage()
    }
  }
  const openToothlensUrl = (transactionId) => {
    window.open(`${AppConfigs.toothlensUrl}/${transactionId}`, '_self')
  }

  return (
    <section className="home-container">
      <HomePageView
        register={register}
        setValue={setValue}
        getValues={getValues}
        handleSubmit={handleSubmit(onSubmit)}
        isErrorPhoneNumber={isErrorPhoneNumber}
        hasJoinedToothlens={hasJoinedToothlens}
      />

      {modalOtp && (
        <PopupOtp
          setModal={setModalOtp}
          setOtp={setOtp}
          otp={otp}
          handleChangeOTP={handleChangeOTP}
          handleSubmitOTP={handleSubmitOTP}
          closeModalOTP={closeModalOTP}
          handleResendOTP={handleResendOTP}
          isErrorOTP={isErrorOTP}
        />
      )}
    </section>
  )
}

export default HomePage
